import * as React from "react";

import {
  useTabStyles_unstable,
  type ForwardRefComponent,
} from "@fluentui/react-components";
import type { AppTabProps } from "./AppTab.types";
import { useAppTab } from "./useAppTab";
import { renderAppTab } from "./renderAppTab";

export const AppTab: ForwardRefComponent<AppTabProps> = React.memo(
  React.forwardRef<HTMLButtonElement, AppTabProps>((props, ref) => {
    const state = useAppTab(props, ref);
    useTabStyles_unstable(state);
    return renderAppTab(state, props);
  })
) as ForwardRefComponent<AppTabProps>;

AppTab.displayName = "next/AppTab";
